/**
 * Shared ToggleSwitch reveal for local search and hash-fragment scroll.
 * Dispatches synthetic `beforematch` on collapsed `._toggle-content._toggle-off`
 * ancestors. Callers must not strip `hidden`; ToggleSwitch owns that attribute.
 */

/**
 * Collects collapsed ToggleSwitch content ancestors of `from`.
 * Matches `._toggle-content._toggle-off` whether or not `hidden="until-found"` is present.
 * Innermost ancestors are listed first (walk from the target toward the root).
 */
export function collectCollapsedToggleAncestors(from: HTMLElement | null): HTMLElement[] {
    if (!from) {
        return [];
    }
    const collapsed: HTMLElement[] = [];
    let node: HTMLElement | null = from;
    while (node) {
        if (node.classList.contains('_toggle-content') && node.classList.contains('_toggle-off')) {
            collapsed.push(node);
        }
        node = node.parentElement;
    }
    return collapsed;
}

/**
 * Opens collapsed ToggleSwitch ancestors by dispatching synthetic `beforematch`.
 * ToggleSwitch already listens for that event (standalone or controller).
 *
 * @returns true if at least one ancestor was asked to open
 */
export function revealCollapsedToggleAncestors(from: HTMLElement | null): boolean {
    const collapsed = collectCollapsedToggleAncestors(from);
    if (collapsed.length === 0) {
        return false;
    }
    for (const node of collapsed) {
        node.dispatchEvent(new Event('beforematch'));
    }
    return true;
}
